import { createGlobalStyle } from "styled-components";

import "@fontsource/manrope";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";

const GlobalStyle = createGlobalStyle`
  * {
    outline: none;
    box-sizing: border-box;
    -ms-overflow-style: none;
  }
  html {
    overflow-x: hidden;
  }
  body {
    margin: 0;
    padding: 0;
    background: white;
    font-family: Manrope;
    overflow-x: hidden;
    min-height: 100vh;
  }
  body.menu-open {
    position: fixed;
    left: 0;
    width: 100vw;
  }
`;

export default GlobalStyle;
